// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_cj-2";
export var aiChatCartContainerExit = "_cj-4";
export var aiChatContainerLarge = "_cj-0";
export var aiChatContainerSmall = "_cj-1";
export var aiChatIcon = "_cj-6";
export var slideInFromRight = "_cj-3";
export var slideOutToRight = "_cj-5";